import { PIAPI } from '@core/base';
import { CreateTaskRequest, TaskResponse } from '@core/types';
import { Kling } from './types';

export class KlingTryonAPI extends PIAPI {
    private config: Kling.Config;

    constructor(apiKey: string, config: Kling.Config = {}, baseUrl?: string) {
        super(apiKey, baseUrl);
        this.config = config;
    }

    private static DEFAULT_PARAMS = {
        batch_size: 1,
    };

    private createTryonRequest(params: Kling.VirtualTryonParams): CreateTaskRequest {
        // 验证必需参数
        if (!params.model_input) {
            throw new Error("model_input is required");
        }

        // 验证互斥参数
        if (params.dress_input && (params.upper_input || params.lower_input)) {
            throw new Error("Cannot use dress_input together with upper_input or lower_input");
        }

        if (!params.dress_input && !params.upper_input && !params.lower_input) {
            throw new Error("Must provide either dress_input or upper_input/lower_input");
        }

        const request: CreateTaskRequest = {
            model: "kling",
            task_type: "ai_try_on",
            input: {
                ...KlingTryonAPI.DEFAULT_PARAMS,
                ...params,
            },
        };

        if (this.config.webhookUrl && this.config.webhookSecret) {
            request.config = {
                webhook_config: {
                    endpoint: this.config.webhookUrl,
                    secret: this.config.webhookSecret,
                },
            };
        }

        return request;
    }

    async tryOn(params: Kling.VirtualTryonParams): Promise<TaskResponse> {
        const request = this.createTryonRequest(params);
        return this.createTask(request);
    }

    async tryOnAndWait(params: Kling.VirtualTryonParams, options?: {
        maxAttempts?: number;
        interval?: number;
    }): Promise<TaskResponse> {
        const request = this.createTryonRequest(params);
        return this.createTaskAndWait(request, options);
    }
}
